var Pdf = require('./lib/pdf-page-counter.js');
module.exports = Pdf;